<div class="flex h-screen w-screen flex-wrap content-center justify-center p-5">
  @if (isLoading) {
    <div class="w-[2.5rem] self-center">
      <app-loader padding="0" [diameter]="'22'" height="100%"></app-loader>
    </div>
  } @else {
    <div class="h-2/3 text-center">
      <div class="mb-5 text-3xl font-medium">
        {{ error[errorCode].title || 'Error' | translate }}
      </div>
      <div class="mb-5 text-lg text-gray-700">
        @if (error[errorCode].subTitle) {
          <span>{{ error[errorCode].subTitle | translate }}</span>
          <br />
        }
        @if (canRedirectToHomePage || returnUrl) {
          <div class="flex justify-center">
            {{ 'youCanGoBack' | translate }}&nbsp;
            @if (canRedirectToHomePage && returnUrl) {
              <div>
                <a class="error__link" [routerLink]="returnUrl">{{
                  'previous' | translate
                }}</a>
                {{ 'or' | translate }}
                <a class="error__link" [routerLink]="homeUrl">{{
                  'home' | translate
                }}</a>
                {{ 'pages' | translate }}
              </div>
            }
            @if (canRedirectToHomePage && !returnUrl) {
              <div>
                <a class="error__link" [routerLink]="homeUrl">{{
                  'home' | translate
                }}</a>
                {{ 'page' | translate }}
              </div>
            }
            @if (!canRedirectToHomePage && returnUrl) {
              <div>
                <a class="error__link" [routerLink]="returnUrl">{{
                  'previous' | translate
                }}</a>
                {{ 'page' | translate }}
              </div>
            }
          </div>
        }
      </div>
      @if (!!error[errorCode].src) {
        <img
          class="error-img"
          [src]="error[errorCode].src"
          alt="access-denied" />
      }
      @if (errorCode === 'versionError') {
        <button mat-raised-button color="primary" (click)="update()">
          {{ 'newVersionUpdate' | translate }}
        </button>
      }
      @if (errorCode === '403') {
        <button mat-raised-button color="primary" (click)="changeUser()">
          {{ 'changeUser' | translate }}
        </button>
      }
    </div>
  }
</div>
